import { THEME } from 'GlobalStyles';

export const ICON_COLOR = THEME.palette.grey[600];
export const DISABLED_COLOR = THEME.palette.grey[300];
